import { render } from "./export-attendance-reports.vue?vue&type=template&id=e5b789b2"
import script from "./export-attendance-reports.vue?vue&type=script&lang=js"
export * from "./export-attendance-reports.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__